import dynamic      from "next/dynamic";
import { useState } from "react";

import { useGetLoggedIn }   from "_common/hooks/auth";
import { useGetDeviceType } from "_common/hooks/global";
import {
	useGetChatContainerTabName,
	useGetIsBlockedByStreamer,
	useGetTheatreMode,
	useSetLoginPopup,
	useToggleChatContainer
} from "_common/hooks/global";
import { useGetSessionEnded }  from "_common/hooks/stream";
import { useGetUpdateSession } from "_jotai/liveSession";

const Presentation       = dynamic ( () => import ( "./presentation" ) );
const MobilePresentation = dynamic ( () => import ( "./mobile.presentation" ) );

const ChatContainerWrapper = ( {
	broadcastId, fromStudio,
	chatPoppedOut, isMobile,
	isStreamer = false, previousComments
} ) => {
	const deviceType           = useGetDeviceType ();
	const chatContainerTabName = useGetChatContainerTabName ();
	const toggleChatContainer  = useToggleChatContainer ();
	const theatreModeToggle    = useGetTheatreMode ();
	const isMobileOrTablet     = isMobile || deviceType === "tablet";
	const isLoggedIn           = useGetLoggedIn ();
	const setLoginPopup        = useSetLoginPopup ();
	const sessionData          = useGetUpdateSession ();

	const [ errorModal, setErrorModal ]          = useState ( false );
	const [ donationOption, setDonationOption ]  = useState ( false );
	const [ displayModal, setDisplayModal ]      = useState ( false );
	const [ autoDonationModal, setAutoDonation ] = useState ( false );
	const pollsEnabled                           = sessionData?.pollsEnabled;
	const isSessionEnded                         = useGetSessionEnded ();
	const isBlockedByStreamer                    = useGetIsBlockedByStreamer ();

	const toggleErrorModal = () => {
		setErrorModal ( val => !val );
	};

	const handleDisabledChatInputClick = chatMode => {
		if ( !isLoggedIn )
			return setLoginPopup ( true );

		if ( chatMode !== "donorOnly" )
			return;

		setDonationOption ( "Sticker" );
		setAutoDonation ( true );
	};

	const handleModalOptions = option => {
		if ( !option ) return;

		if ( !isLoggedIn )
			return setLoginPopup ( true );

		setAutoDonation ( false );
		setDonationOption ( option );
		// setDisplayModal ( val => !val );
	};

	const closeDonationModals = () => {
		setDisplayModal ( false );
		setDonationOption ( null );
		setErrorModal ( false );
		setAutoDonation ( false );
	};

	const handleModal = type => {
		if ( type === "back" ) {
			setDonationOption ( null );

			if ( !autoDonationModal )
				return setDisplayModal ( true );
		}
		if ( !donationOption ) {
			setDisplayModal ( prev => !prev );
		} else {
			setDonationOption ( null );
		}

	};

	let leaderboardData = {
		isLive                 : sessionData?.isLeaderBoardLive || false,
		date                   : sessionData?.startTimeUTC || undefined,
		broadcasterSportsFanId : sessionData?.broadcaster?.sportsFan?.id || undefined,
		broadcasterName        : sessionData?.broadcaster?.sportsFan?.name || "",
		giveAwayCoins          : sessionData?.giveAwayCoins || 0
	};

	const isFanLeaderboardLive = leaderboardData.isLive;
	const broadcasterId        = sessionData?.broadcaster?.sportsFan?.id;

	const tabs = [
		"Live Chat",
		"Fan Rank",
		"Donations"
	];

	const onCloseChatContainerModal = () => {
		toggleChatContainer ( false );
	};

	if ( isMobileOrTablet )
		return (
			<MobilePresentation
				adsEnabled                = { sessionData?.showAds ?? true }
				broadcasterId             = { broadcasterId }
				broadcastId               = { broadcastId }
				chatContainerTabName      = { chatContainerTabName }
				chatPoppedOut             = { chatPoppedOut }
				closeDonationModals       = { closeDonationModals }
				displayModal              = { displayModal }
				donationOption            = { donationOption }
				errorModal                = { errorModal }
				fromStudio                = { fromStudio }
				handleModal               = { handleModal }
				handleModalOptions        = { handleModalOptions }
				isBlockedByStreamer       = { isBlockedByStreamer }
				isFanLeaderboardLive      = { isFanLeaderboardLive }
				isMobile                  = { isMobile }
				isSessionEnded            = { isSessionEnded }
				isStreamer                = { isStreamer }
				leaderboardData           = { leaderboardData }
				onCloseChatContainerModal = { onCloseChatContainerModal }
				pollsEnabled              = { pollsEnabled }
				previousComments          = { previousComments }
				tabs                      = { tabs }
				theatreModeToggle         = { theatreModeToggle }
				toggleErrorModal          = { toggleErrorModal }
			/>
		);

	return (
		<div style = { { minWidth: "25vw" } }>
			<Presentation
				autoDonationModal            = { autoDonationModal }
				broadcasterId                = { broadcasterId }
				broadcastId                  = { broadcastId }
				chatContainerTabName         = { chatContainerTabName }
				chatPoppedOut                = { chatPoppedOut }
				closeDonationModals          = { closeDonationModals }
				displayModal                 = { displayModal }
				donationOption               = { donationOption }
				errorModal                   = { errorModal }
				fromStudio                   = { fromStudio }
				handleDisabledChatInputClick = { handleDisabledChatInputClick }
				handleModal                  = { handleModal }
				handleModalOptions           = { handleModalOptions }
				isBlockedByStreamer          = { isBlockedByStreamer }
				isFanLeaderboardLive         = { isFanLeaderboardLive }
				isMobile                     = { isMobile }
				isSessionEnded               = { isSessionEnded }
				isStreamer                   = { isStreamer }
				leaderboardData              = { leaderboardData }
				onCloseChatContainerModal    = { onCloseChatContainerModal }
				pollsEnabled                 = { pollsEnabled }
				previousComments             = { previousComments }
				tabs                         = { tabs }
				theatreModeToggle            = { theatreModeToggle }
				toggleErrorModal             = { toggleErrorModal }
			/>
		</div>
	);
};

export default ChatContainerWrapper;
